<template>
  <div class="page-box">
    <Header />
    <!-- Banner 区 -->
    <div class="page-content bg-color-EAF1FA">
      <div class="top-box max-width-1920"
        :style="{ backgroundImage: `url(${require('@/assets/product/robot/LM202/banner.jpg')})` }">
        <div class="content-positioning" data-aos="fade-up" :style="contentStype">
          <div class="title-1" :style="titleStyle">AI 智能零售巡检机器人 LM202</div>
          <div class="title-2">面向书店/图书馆及中大商超<br>
智能巡检 + 人机交互一体化解决方案
            <div class="title-3" @click="openContactUs">
              申请试用
            </div>
          </div>
        </div>

      </div>

      <!-- 核心能力 -->
      <div class="capability-section" data-aos="fade-up">
        <div class="section-title-small">核心技术</div>
        <div class="section-subtitle">三大核心模块 打造场景专属智能巡检机器人</div>
        <div class="capability-grid">
          <div class="capability-card" v-for="(item, index) in capabilityList" :key="index">
            <img class="capability-icon" :src="item.icon" alt="">
            <div class="capability-name">{{ item.name }}</div>
            <div class="capability-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>

      <div class="capability-section" data-aos="fade-up">
        <div class="section-title-small">核心卖点</div>
        <div class="section-subtitle">一站式解决图书场景全流程运营管理需求</div>
        <div class="capability-grid1">
          <div class="capability-card" v-for="(item, index) in featureList" :key="index">
            <img class="capability-icon" :src="item.icon" alt="">
            <div class="capability-name">{{ item.name }}</div>
            <div class="capability-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>


      <!-- 技术特点 -->
      <div class="feature-section" data-aos="fade-up"
        :style="{ backgroundImage: `url(${require('@/assets/product/robot/LM202/icon8.jpg')})` }">
      </div>


      <div class="flor3" data-aos="fade-up">
        <div class="f2-title">适配应用场景</div>
        <div class="f2-subtitle">聚焦零售商超领域 适配不同规模零售场景</div>

        <div class="scene-cards-container">
          <div class="scene-card-item" v-for="(scene, index) in sceneList" :key="index">
            <div class="f3-card">
              <img class="bgimg" :src="scene.icon" />
              <div class="title">{{ scene.name }}</div>
              <div class="subtitle">{{ scene.desc }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部联系方式 -->
      <Footer />
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import metaInfo from "@/common/util/metaInfo"

export default {
  metaInfo: metaInfo.lm202,
  components: {
    Header,
    Footer
  },
  data() {
    return {
      capabilityList: [
        { icon: require("@/assets/product/robot/LM202/icon1.svg"), name: '人机交互模块', desc: '多语言语音识别，对话准确率 98.5%，支持多轮对话，无需重复唤醒，交互体验接近真人。' },
        { icon: require("@/assets/product/robot/LM202/icon2.svg"), name: '图书专用 AI 模型', desc: '图书场景专属 AI 模型，识别准确率 99%，精准识别缺货、错架、破损，适配各类陈列场景。' },
        { icon: require("@/assets/product/robot/LM202/icon3.svg"), name: '边缘算力与避障模块', desc: '本地数据处理，响应延迟 100ms，断网可工作；低噪灵活避障，轻松穿梭狭窄书架通道。' },
      ],
      featureList: [
        { icon: require("@/assets/product/robot/LM202/icon4.svg"), name: '智能迎宾问询', desc: '主动识别读者，推荐适配图书，解答借阅规则等问题，提升借阅效率。' },
        { icon: require("@/assets/product/robot/LM202/icon5.svg"), name: '专业图书导购', desc: '内置百万级图书数据库，推荐相关图书，介绍内容，提升销售转化率。' },
        { icon: require("@/assets/product/robot/LM202/icon6.svg"), name: '缺货 + 价签检查', desc: '自动识别缺货位置，核对价签准确性，生成清单方便补货修正。' },
        { icon: require("@/assets/product/robot/LM202/icon7.svg"), name: '高效库存盘点', desc: '每小时盘点 200 组书架，效率提升 10 倍，准确率 99.5%，规范图书陈列。' }
      ],
      sceneList: [
        { icon: require("@/assets/product/robot/LM202/icon9.png"), name: '综合型书店', desc: '适配开放式布局、人流量大、品类丰富的综合型书店，提供导购、库存管理、图书巡检等服务，提升运营效率与读者体验。' },
        { icon: require("@/assets/product/robot/LM202/icon10.png"), name: '公共图书馆', desc: '针对藏书量大、书架密集的公共图书馆，高效完成图书盘点、错架纠正、读者引导，减轻人工压力，规范图书管理秩序。' },
        { icon: require("@/assets/product/robot/LM202/icon11.png"), name: '专业图书馆', desc: '适配专业图书分类集中、借阅人群固定的专业图书馆，支持定制巡检逻辑，助力文献规范管理与精准查找，提升运维效率。' },

      ]
    }
  },
  methods: {
    openContactUs() {
      this.$root.$emit('openContactUs', 'LM202')
    }
  }
}
</script>

<style lang="less" scoped>
.page-box {
  background-color: #fff;
}

/* Banner 区域 */
.top-box {
  width: 100%;
  min-width: 1200px;
  height: 600px;
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center;
  display: flex;
  justify-content: center;
}

.max-width-1920 {
  max-width: 1920px;
  width: 100%;
  padding-top: 70px;
}

.content-positioning {
  width: 1200px;
  text-align: center;
  padding-top: 100px;
}

.title-1 {
  font-weight: bold;
  font-size: 42px;
  color: #222222;
  line-height: 57px;
  letter-spacing: 1px;
  text-align: justify;
}

.title-2 {
  font-size: 24px;
  color: #222222;
  line-height: 42px;
  text-align: justify;
  margin-top: 33px;
}

.title-3 {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 180px;
  height: 50px;
  background: linear-gradient(270deg, #29ABFE 0%, #016BFF 100%);
  border-radius: 8px;
  font-weight: bold;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 16px;
  text-align: center;
  cursor: pointer;
}


/* 通用区块样式 */
.section-title {
  font-weight: bold;
  font-size: 32px;
  color: #222222;
  line-height: 34px;
  text-align: center;
  margin-bottom: 40px;
}

.section-title-small {
  font-weight: bold;
  font-size: 32px;
  color: #222222;
  line-height: 34px;
  text-align: center;
  margin-bottom: 10px;
}

.section-subtitle {
  font-size: 16px;
  color: #595859;
  line-height: 21px;
  text-align: center;
}

/* 核心能力 */
.capability-section {
  width: 100%;
  padding: 80px 0;
  background: #ffffff;
}

.capability-grid {
  width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-top: 20px;
  ;
}

.capability-grid1 {
  width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-top: 20px;
  ;
}

.capability-card {
  background: linear-gradient(180deg, #FAFCFF 0%, #ECF2FF 100%);
  border-radius: 6px;
  border: 1px solid #ECF2FF;
  padding: 32px;
  text-align: center;
  transition: all 0.3s;
  flex: 1;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
  }
}

.capability-icon {
  width: 40px;
  height: 40px;
  margin-bottom: 16px;
  object-fit: contain;
}

.capability-name {
  font-size: 20px;
  font-weight: 600;
  color: #222222;
  margin-bottom: 8px;
}

.capability-desc {
  font-size: 14px;
  color: #666666;
  line-height: 22px;
}


/* 技术特点 */
.feature-section {
  width: 100%;
  padding: 80px 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 80vh;
  /* 视窗高度的 80% */
}



.flor3 {
  width: 100%;
  background: #F4F5FB;
  display: flex;
  flex-direction: column;
  padding: 80px 0 80px;

  .f2-title {
    font-weight: bold;
    font-size: 32px;
    color: #222222;
    line-height: 34px;
    text-align: center;
    margin-bottom: 35px;
  }

  .f2-subtitle {
    font-size: 16px;
    color: #222222;
    line-height: 30px;
    text-align: center;
    margin-bottom: 40px;
  }

  .scene-cards-container {
    width: 1200px;
    margin: 0 auto;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }

  .scene-card-item {
    border-radius: 6px;
    overflow: hidden;
  }

  .f3-card {
    background: #ffffff;
    border-radius: 6px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .f3-card .bgimg {
    width: 100%;
    height: 240px;
    object-fit: cover;
  }

  .f3-card .title {
    font-weight: bold;
    font-size: 22px;
    color: #222222;
    line-height: 22px;
    text-align: left;
    padding: 20px;
    margin: 0;
  }

  .f3-card .subtitle {
    font-size: 14px;
    color: #222222;
    line-height: 22px;
    text-align: justify;
    padding: 0 20px 20px 20px;
    margin: 0;
    flex: 1;
  }

}
</style>
